import type { Vec3 } from '../geo/types';

/** Distance-triggered contacts. Stops, seeks and time gaps do not create catch-up footsteps. */
export class MotionAudio {
  private last: Vec3 | null = null;
  private time = 0;
  private travel = 0;
  private struck = -Infinity;
  private side: -1 | 1 = -1;

  constructor(
    private readonly stride = 0.7,
    private readonly interval = 0.28
  ) {}

  reset(): void {
    this.last = null;
    this.travel = 0;
    this.struck = -Infinity;
  }

  update(position: Vec3, now: number): -1 | 1 | null {
    const before = this.last,
      dt = now - this.time;
    this.last = [...position];
    this.time = now;
    if (!before) return null;
    const distance = Math.hypot(position[0] - before[0], position[2] - before[2]);
    if (dt < 0 || dt > 0.5 || distance > Math.max(3, dt * 8)) {
      this.travel = 0;
      return null;
    }
    if (distance < 0.0001) return null;
    this.travel = Math.min(this.stride * 2, this.travel + distance);
    if (this.travel < this.stride || now - this.struck < this.interval) return null;
    this.travel -= this.stride;
    this.struck = now;
    this.side = this.side === -1 ? 1 : -1;
    return this.side;
  }
}
